import { events as fiberEvents } from '@react-three/fiber';

const SKIP_HOVER = new Set([
  'onPointerMove',
  'onPointerOver',
  'onPointerEnter',
  'onPointerOut',
  'onPointerLeave',
]);

/**
 * Skip hover raycasts (expensive on big point clouds).
 * Keep pointerdown/click so Info can pick blocks and holes.
 * Pan orbit is still cheap because block/hole raycasts no-op while clickType is pan.
 */
export function clickOnlyEvents(store) {
  const base = fiberEvents(store);
  const handlers = {};
  Object.keys(base.handlers || {}).forEach((key) => {
    if (SKIP_HOVER.has(key)) return;
    handlers[key] = base.handlers[key];
  });
  return { ...base, handlers };
}
